import axiosInstance from "../../axios/axiosInstance";
import { GET_ADMIN_SETTINGS_URL, UPDATE_ADMIN_SETTINGS_URL } from "../../constants";

export const getAdminSettings = () => onResponse => {
    try {
        axiosInstance.get(GET_ADMIN_SETTINGS_URL)
            .then((response) => {
                onResponse(response.data);
            })
            .catch((err) => {
                onResponse(err.response);
            });
    } catch (error) {
        // Handle error
    }
};

export const updateAdminSettings = (props) => onResponse => {
    try {
        axiosInstance.post(UPDATE_ADMIN_SETTINGS_URL, props)
            .then((response) => {
                onResponse(response.data);
            })
            .catch((err) => {
                onResponse(err.response);
            });
    } catch (error) {
        // Handle error
    }
};